import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'app-who-are-we',
  templateUrl: './who-are-we.component.html',
  styleUrls: ['./who-are-we.component.css']
})
export class WhoAreWeComponent implements OnInit {

  constructor(
    private router: Router, private meta: Meta, private title: Title
  ) { }

  ngOnInit(): void {
    this.metaTagAdd()  //////  Meta tags add for SEO  //////
  }
  metaTagAdd() {
    this.title.setTitle('Soul Searching Spiritual Journey India');

    this.meta.updateTag({
      name: 'description',
      content: 'Experience Seamless Pilgrimage Travel Service in India with My Yatra360. We offer Religious Travel Services in India and Luxury Spiritual Travel in India. Book now.'
    });

    this.meta.updateTag({
      name: 'keywords',
      content: 'Soul Searching Spiritual Journey India, Seamless Pilgrimage Travel Service India, Religious Travel Services India, Luxury Spiritual Travel India'
    });
  }
}
